import { render, staticRenderFns } from "./failRecord.vue?vue&type=template&id=8eddfb92&scoped=true"
import script from "./failRecord.vue?vue&type=script&lang=js"
export * from "./failRecord.vue?vue&type=script&lang=js"
import style0 from "./failRecord.vue?vue&type=style&index=0&id=8eddfb92&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eddfb92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eddfb92')) {
      api.createRecord('8eddfb92', component.options)
    } else {
      api.reload('8eddfb92', component.options)
    }
    module.hot.accept("./failRecord.vue?vue&type=template&id=8eddfb92&scoped=true", function () {
      api.rerender('8eddfb92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/resource/trackSendingManagement/component/failRecord.vue"
export default component.exports